import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { AllocationViewSupportSMSFacade } from './allocation-view-support-sms.facade';

@Injectable({
  providedIn: 'root',
})
export class AllocationViewSupportSMSGuard {
  constructor(private allocationViewSupportSMSFacade: AllocationViewSupportSMSFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.allocationViewSupportSMSFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.allocationViewSupportSMSFacade);
  }
}
